import superFetch from '../utils/super-fetch';
import authService from './auth-service';

const fetchTeamOptionsForAdmin = () => {
  const url = '/admin/teams';
  const options = {
    method: 'OPTIONS',
  };
  return superFetch(url, options)
    .then(response => response.json());
};

const fetchTeamsForAdmin = (params) => {
  // fetch all teams
  const url = '/admin/teams';
  const options = {
    method: 'GET',
    params,
  };
  return superFetch(url, options)
    .then(response => response.json());
};

const addTeamForAdmin = (params) => {
  // add a team from the admin page
  const {
    teamName: name,
    teamMembers: users,
    teamColor: avatar_color,
  } = params;
  const url = '/admin/teams';
  const options = {
    method: 'POST',
  };
  const body = {
    name,
    users,
    avatar_color,
  };

  return superFetch(url, options, JSON.stringify(body))
    .then(response => response.json());
};

const addTeamMemberForAdmin = (params) => {
  // add team members to a team from the admin page
  const url = `/admin/teams/${params.id}`;
  const options = {
    method: 'PATCH',
  };
  const body = [{
    op: 'add',
    path: '/users',
    value: params.newTeamMember.user_id,
  }];

  return superFetch(url, options, JSON.stringify(body))
    .then(data => data.json());
};

const removeTeamMemberForAdmin = (params) => {
  const url = `/admin/teams/${params.id}`;
  const options = {
    method: 'PATCH',
  };
  const body = [{
    op: 'remove',
    path: `/users/${params.memberToRemove.id}`,
  }];

  return superFetch(url, options, JSON.stringify(body))
    .then(data => data.json());
};

const updateTeamForAdmin = (params) => {
  // update a team from the admin page
  const url = `/admin/teams/${params.id}`;
  const options = {
    method: 'PUT',
  };
  const {
    id,
    teamName: name,
    teamColor: avatar_color,
    deleted,
  } = params;
  const body = {
    id,
    name,
    avatar_color,
    deleted,
  };

  return superFetch(url, options, JSON.stringify(body))
    .then(data => data.json());
};

const fetchDealsAndTransactionsESForAdmin = (params, requestId) => {
  const url = '/admin/es/dealsandtransactions';
  const options = {
    method: 'GET',
    params,
  };
  return superFetch(url, options)
    .then(data => data.json())
    .then(data => ({ ...data, requestId }));
};

const linkDealsAndTransactionsForAdmin = (params) => {
  const {
    deal_pk,
    transaction_pk,
  } = params;
  const url = `/admin/deals/${deal_pk}/transactions/${transaction_pk}`;
  const options = {
    method: 'POST',
  };
  return superFetch(url, options)
    .then(response => response);
};

const unLinkDealsAndTransactionsForAdmin = (params) => {
  const {
    deal_pk,
    transaction_pk,
  } = params;
  const url = `/admin/deals/${deal_pk}/transactions/${transaction_pk}`;
  const options = {
    method: 'DELETE',
  };
  return superFetch(url, options)
    .then(response => response);
};

const fetchDealForAdmin = (id) => {
  const url = `/admin/deals/${id}`;
  const options = {
    method: 'GET',
  };
  return superFetch(url, options)
    .then(response => response.json());
};

const fetchGroups = (params) => {
  // fetch all groups
  const url = '/adminlabs/groups';
  const options = {
    method: 'GET',
    params,
  };
  return superFetch(url, options)
    .then(response => response.json())
    .catch(error => console.error('Error fetching groups'));
};

const fetchGroup = (id) => {
  // fetch a group by id
  const url = `/adminlabs/groups/${id}`;
  const options = {
    method: 'GET',
  };
  return superFetch(url, options)
    .then(response => response.json())
    .catch(error => console.error('Error fetching group'));
};

const fetchFlags = (params) => {
  // fetch all feature flags
  const url = '/adminlabs/flags';
  const options = {
    method: 'GET',
    params,
  };
  return superFetch(url, options)
    .then(response => response.json())
    .catch(error => console.error('Error fetching feature flags'));
};

const addGroup = (params) => {
  // add a group from the admin page
  const url = '/adminlabs/groups';
  const options = {
    method: 'POST',
  };

  return superFetch(url, options, JSON.stringify(params))
    .then(response => response.json())
    .catch(error => console.error('Error adding group from admin page'));
};

const addUserToGroup = (params) => {
  // add a user to a group from the admin page
  const url = '/adminlabs/groups/m2m/users';
  const options = {
    method: 'POST',
  };

  return superFetch(url, options, JSON.stringify(params))
    .then(response => response.json())
    .catch(error => console.error('Error adding user to group from admin page'));
};

const removeUserFromGroup = (params) => {
  // remove a user from a group from the admin page
  const url = '/adminlabs/groups/m2m/users';
  const options = {
    method: 'DELETE',
  };

  return superFetch(url, options, JSON.stringify(params))
    .then(response => response.json())
    .catch(error => console.error('Error removing user from a group from admin page:'));
};

const fetchGroupUsers = (params) => {
  const url = '/adminlabs/users';
  const options = {
    method: 'GET',
    params,
  };

  return superFetch(url, options)
    .then(data => data.json())
    .catch(() => {
      console.error('Error fetching search results.');
    });
};

const fetchUsers = (params) => {
  const url = '/adminlabs/groups/search/users';
  const options = {
    method: 'GET',
    params,
  };

  return superFetch(url, options)
    .then(data => data.json())
    .catch(() => {
      console.error('Error fetching search results.');
    });
};

const addFlagToGroup = (params) => {
  // add a flag to a group from the admin page
  const url = '/adminlabs/groups/m2m/flags';
  const options = {
    method: 'POST',
  };

  return superFetch(url, options, JSON.stringify(params))
    .then(response => response.json())
    .catch(error => console.error('Error adding flag to group from admin page'));
};

const removeFlagFromGroup = (params) => {
  // remove a flag from a group from the admin page
  const url = '/adminlabs/groups/m2m/flags';
  const options = {
    method: 'DELETE',
  };

  return superFetch(url, options, JSON.stringify(params))
    .then(response => response.json())
    .catch(error => console.error('Error removing flag from group from admin page'));
};

// toggle flag on for all users in a group
const turnOnFlagForAllUsers = (params) => {
  const url = '/adminlabs/users/m2m/flags';
  const options = {
    method: 'POST',
  };

  return superFetch(url, options, JSON.stringify(params))
    .then(response => response.json())
    .catch(error => console.error('Error adding flag to users from admin page'));
};

// toggle flag off for all users in a group
const turnOffFlagForAllUsers = (params) => {
  const url = '/adminlabs/users/m2m/flags';
  const options = {
    method: 'DELETE',
  };

  return superFetch(url, options, JSON.stringify(params))
    .then(response => response.json())
    .catch(error => console.error('Error removing flag from all users from admin page'));
};

const exportBadTransactions = () => {
  const url = '/mbb/export_mta_merge_failures';
  const options = {
    method: 'POST',
  };
  return superFetch(url, options);
};

const searchDealsForManagement = (params) => {
  const url = '/admin/manage-deals';
  const options = {
    method: 'GET',
    params,
  };
  return superFetch(url, options)
    .then(data => data.json());
};

const searchDealsRestoreManagement = (params) => {
  const url = '/admin/manage-deals/deal_search';
  const options = {
    method: 'GET',
    params,
  };
  return superFetch(url, options)
    .then(data => data.json());
};

const getDealDetails = (dealId) => {
  const url = `/admin/deals/${dealId}/manage`;
  const options = {
    method: 'GET',
  };
  return superFetch(url, options)
    .then(data => data.json());
};

const refreshUserDealData = (params) => {
  const url = '/admin/manage-deals/user-deal-refresh/';
  const options = {
    method: 'POST',
  };
  const body = {
    email: params.email,
  };

  return superFetch(url, options, JSON.stringify(body))
    .then(response => response.json());
};

const fetchUserDealRefreshHistory = (params = {}) => {
  const url = '/admin/manage-deals/user-deal-refresh/';
  const options = {
    method: 'GET',
    params,
  };
  return superFetch(url, options)
    .then(response => response.json());
};

/**
 * Fetch all user deal restrictions (no filtering)
 * Used for admin pages that need to list all restrictions
 * @returns {Promise<Object>} Promise resolving to { count: number, results: Array }
 */
const fetchUserDealRestrictions = async () => {
  try {
    const resp = await superFetch('/user/dealrestrictions', { method: 'GET' });
    if (!resp.ok) return { count: 0, results: [] };
    const data = await resp.json();
    return {
      count: data.count || (Array.isArray(data.results) ? data.results.length : 0),
      results: Array.isArray(data.results) ? data.results : [],
    };
  } catch (e) {
    console.error('Failed to load user deal restrictions');
    return { count: 0, results: [] };
  }
};

/**
 * Paged + searchable CPro user restrictions fetch.
 * The backend may support page,page_size,search (email). If not, front-end will filter.
 */
const fetchPagedUserDealRestrictions = async ({ page = 1, page_size = 25, search = '' } = {}) => {
  try {
    const params = { page, page_size };
    if (search) params.search = search; // assuming backend supports search by email
    const resp = await superFetch('/admin/manage-user/user-deal-type-restrictions', { method: 'GET', params });
    if (!resp.ok) return { count: 0, results: [], next: null };
    const data = await resp.json();
    return {
      count: data.count || 0,
      results: Array.isArray(data.results) ? data.results : [],
      next: data.next || null,
    };
  } catch (e) {
    console.error('Failed to load paged user deal restrictions');
    return { count: 0, results: [], next: null };
  }
};



/** Update deal restrictions for a specific user */
const updateUserDealRestrictions = async (userId, restrictedDealTypes = [], action = '', dealType = '') => {
  if (!userId) return { ok: false };
  try {
    const body = {
      user_id: userId,
      restricted_deal_types: restrictedDealTypes,
      action: action,
      deal_type: dealType
    };
    const resp = await superFetch('/admin/manage-user/user_deal_type_restrictions/update_restrictions', { method: 'PATCH' }, JSON.stringify(body));
    const data = resp.ok ? await resp.json() : null;
    return { ok: resp.ok, data };
  } catch (e) {
    console.error('Failed to update user deal restrictions');
    return { ok: false };
  }
};


// ---------------------------------------------------------------------------
// Admin Proxy Access Management
// ---------------------------------------------------------------------------

const searchAdminProxyUser = (email) => {
  const params = new URLSearchParams({ email });
  return superFetch(`/admin/proxy-access/search?${params.toString()}`, {
    method: 'GET',
  }).then(res => res.json());
};

const grantAdminProxyAccess = (userEmail, proxyEmail) => {
  const options = {
    method: 'POST',
  };
  return superFetch('/admin/proxy-access/grant', options, JSON.stringify({ user_email: userEmail, proxy_email: proxyEmail }))
    .then(res => res.json());
};

const bulkValidateAdminProxyFile = (file) => {
  return uploadAdminFile('/admin/proxy-access/bulk-validate', file);
};

const bulkGrantAdminProxyAccess = (records) => {
  const options = {
    method: 'POST',
  };
  return superFetch('/admin/proxy-access/bulk-grant', options, JSON.stringify({ records }))
    .then(res => res.json());
};

const revokeAdminProxyAccess = (proxyAccessId) => {
  const options = {
    method: 'DELETE',
  };
  return superFetch(`/admin/proxy-access/${proxyAccessId}/revoke`, options)
    .then(res => {
      if (res.status === 204) return { success: true, message: 'Proxy access revoked.' };
      return res.json().then(data => ({ ...data, success: res.ok }));
    })
    .catch(() => ({ success: false, error: 'Failed to revoke proxy access.' }));
};

const bulkRevokeAdminProxyAccess = (proxyAccessIds) => {
  const options = {
    method: 'POST',
  };
  return superFetch('/admin/proxy-access/bulk-revoke', options, JSON.stringify({ proxy_access_ids: proxyAccessIds }))
    .then(res => res.json());
};

const fetchAdminProxyAccessList = (page = 1, pageSize = 25, search = '') => {
  const params = new URLSearchParams({ page: page.toString(), page_size: pageSize.toString() });
  if (search && search.trim()) params.append('search', search.trim());
  return superFetch(`/admin/proxy-access?${params.toString()}`, { method: 'GET' })
    .then(res => res.json());
};
// ---------------------------------------------------------------------------

/** Fetch audit history for a specific user restriction/user */
const fetchCProUserAudit = async (userId, page = 1, pageSize = 25) => {
  if (!userId) return [];
  try {
    // Placeholder endpoint; adjust to real audit path when available
    const resp = await superFetch(`/admin/manage-user/user_deal_type_restrictions/${userId}/audit_history`, { 
      method: 'GET',
      params: { page, page_size: pageSize }
    });
    if (!resp.ok) return [];
    const data = await resp.json();
    
    // Handle both paginated response format and array format
    if (data.results && Array.isArray(data.results)) {
      return {
        results: data.results,
        has_more: data.next ? true : false,
        next: data.next || null,
        count: data.count || 0
      };
    }
    
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error('Failed to fetch CPro user audit');
    return [];
  }
};


/**
 * Fetch deal type restrictions for specific user IDs
 * Used for deal detail pages to check restrictions for team members
 * @param {Array<number>} userIds - Array of user IDs to fetch restrictions for
 * @returns {Promise<Object>} Promise resolving to restrictions map: { userId: restrictedDealTypes[] }
 */
const fetchUserDealRestrictionsByUserIds = (userIds) => {
  if (!userIds || userIds.length === 0) {
    return Promise.resolve({});
  }

  const url = `/user/dealrestrictions?user_ids=${userIds.join(',')}`;
  const options = {
    method: 'GET',
  };

  return superFetch(url, options)
    .then(response => response.json())
    .then(data => {
      // Transform to Map: { userId: restrictedDealTypes[] }
      const restrictionsMap = {};
      if (data.results && Array.isArray(data.results)) {
        data.results.forEach(restriction => {
          if (restriction.user && restriction.user.id) {
            restrictionsMap[restriction.user.id] = restriction.restricted_deal_types || [];
          }
        });
      }
      return restrictionsMap;
    });
};

const restoreDeletedDeal = async (dealId) => {
  if (!dealId) return Promise.reject(new Error('Missing dealId'));
  const url = `/admin/manage-deals/${dealId}`;
  try {
    const resp = await superFetch(url, { method: 'PATCH' }, JSON.stringify({ is_deleted: false }));
    if (!resp.ok) return Promise.reject(new Error('Failed to restore deal'));
    return await resp.json();
  } catch (e) {
    console.error('restoreDeletedDeal failed');
    return Promise.reject(e);
  }
};

// Fetch audit trail for a deleted/restorable deal
// Returns an array of audit entries (normalized upstream).
// Each entry may contain: modified_timestamp | timestamp, message | action, user_email | email | user.email
const fetchDealAudit = async (dealId) => {
  if (!dealId) return Promise.reject(new Error('Missing dealId'));
  const url = `/admin/manage-deals/${dealId}/audit_history`;
  try {
    const resp = await superFetch(url, { method: 'GET' });
    if (!resp.ok) {
      console.log('fetchDealAudit response not ok');
      return [];
    }
    const data = await resp.json();
    const history = Array.isArray(data.audit_history) ? data.audit_history : [];
    const normalized = history.map(entry => ({
      id: entry.id,
      modified_timestamp: entry.modified || entry.created || null,
      message: entry.message || entry.raw_message || entry.category || '',
      user_id: entry.user_id,
      user_email: entry.user_email || null,
    }));
    return normalized;
  } catch (e) {
    console.error('fetchDealAudit failed');
    return [];
  }
};

// Reusable upload helper
// superFetch rejects with the raw, unread Response for non-2xx statuses; parse its
// JSON body here so callers can surface the backend's actual error message.
const parseAdminErrorResponse = (err) => {
  if (err && typeof err.json === 'function') {
    return err.json().then(
      (body) => { throw { ...body, status: err.status }; },
      () => { throw { error: `Request failed with status ${err.status}.` }; },
    );
  }
  throw err;
};

const uploadAdminFile = (url, file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const options = {
    method: 'POST',
    headers: { Authorization: `JWT ${authService.getToken()}` },
  };
  
  return superFetch(url, options, formData)
    .then(response => response.json())
    .catch(parseAdminErrorResponse);
};

// Reusable bulk update helper
const bulkUpdateAdmin = (url, updates, file = null) => {
  if (file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('updates', JSON.stringify(updates));
    
    const options = {
      method: 'POST',
      headers: { Authorization: `JWT ${authService.getToken()}` },
    };
    
    return superFetch(url, options, formData)
      .then(response => response.json())
      .catch(parseAdminErrorResponse);
  }
  
  const options = {
    method: 'POST',
    headers: { Authorization: `JWT ${authService.getToken()}`, 'Content-Type': 'application/json' },
  };
  return superFetch(url, options, JSON.stringify({ updates }))
    .then(response => response.json())
    .catch(parseAdminErrorResponse);
};

// Pool Accounts Management
const uploadPoolAccountsFile = (file) => {
  return uploadAdminFile('/admin/pool-accounts/upload', file);
};

const bulkUpdatePoolAccounts = (updates, file = null) => {
  return bulkUpdateAdmin('/admin/pool-accounts/bulk-update', updates, file);
};

// FUMO (Managing Office) Service Methods
const uploadFumosFile = (file) => {
  return uploadAdminFile('/admin/fumos/upload', file);
};

const bulkUpdateFumos = (updates, file = null) => {
  return bulkUpdateAdmin('/admin/fumos/bulk-update', updates, file);
};

const fetchPoolAccounts = (page = 1, pageSize = 25, search = '') => {
  const params = new URLSearchParams({
    page: page.toString(),
    page_size: pageSize.toString(),
  });
  
  if (search && search.trim()) {
    params.append('search', search.trim());
  }
  
  const url = `/admin/pool-accounts?${params.toString()}`;
  const options = {
    method: 'GET',
  };
  return superFetch(url, options)
    .then(response => response.json())
    .catch(parseAdminErrorResponse);
};

const fetchFumos = (page = 1, pageSize = 25, search = '') => {
  const params = new URLSearchParams({
    page: page.toString(),
    page_size: pageSize.toString(),
  });
  
  if (search && search.trim()) {
    params.append('search', search.trim());
  }
  
  const url = `/admin/fumos?${params.toString()}`;
  const options = {
    method: 'GET',
  };
  return superFetch(url, options)
    .then(response => response.json())
    .catch(parseAdminErrorResponse);
};

// Reusable file download helper - uses presigned URL like existing attachments
const downloadAdminFile = (url, filename) => {
  const options = {
    method: 'GET',
    headers: { Authorization: `JWT ${authService.getToken()}` },
  };
  
  return superFetch(url, options)
    .then(response => response.json())
    .then(data => {
      if (!data.download_url) {
        throw new Error('No download URL received');
      }
      
      // Validate URL is a safe HTTP/HTTPS link before navigation
      const downloadUrl = data.download_url;
      let sanitizedUrl;
      try {
        const urlObj = new URL(downloadUrl);
        if (urlObj.protocol !== 'http:' && urlObj.protocol !== 'https:') {
          throw new Error('Invalid URL protocol');
        }
        // Use the sanitized URL from URL object
        sanitizedUrl = urlObj.href;
      } catch (e) {
        throw new Error('Invalid download URL format');
      }
      // Download directly from S3 using presigned URL via programmatic link
      const link = document.createElement('a');
      link.setAttribute('href', sanitizedUrl);
      link.setAttribute('style', 'display:none');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      return { success: true };
    })
    .catch((error) => {
      console.error('Download error');
      return parseAdminErrorResponse(error);
    });
};

// File download and info methods for Pool Accounts
const downloadPoolAccountsFile = (filename = 'pool_accounts.xlsx') => {
  return downloadAdminFile('/admin/pool-accounts/download', filename);
};

const getPoolAccountsFileInfo = () => {
  const url = '/admin/pool-accounts/file-info';
  const options = {
    method: 'GET',
  };
  
  return superFetch(url, options)
    .then(response => response.json())
    .catch(parseAdminErrorResponse);
};

// File download and info methods for FUMOs
const downloadFumosFile = (filename = 'fumos.xlsx') => {
  return downloadAdminFile('/admin/fumos/download', filename);
};

const getFumosFileInfo = () => {
  const url = '/admin/fumos/file-info';
  const options = {
    method: 'GET',
  };
  
  return superFetch(url, options)
    .then(response => response.json())
    .catch(parseAdminErrorResponse);
};

const uploadSpocsFile = (file) => uploadAdminFile('/admin/spocs/upload', file);

const bulkUpdateSpocs = (updates, file = null) => (
  bulkUpdateAdmin('/admin/spocs/bulk-update', updates, file)
);

const fetchSpocs = (page = 1, pageSize = 25, search = '') => {
  const params = new URLSearchParams({ page: page.toString(), page_size: pageSize.toString() });
  if (search && search.trim()) params.append('search', search.trim());
  return superFetch(`/admin/spocs?${params.toString()}`, { method: 'GET' })
    .then(response => response.json())
    .catch(parseAdminErrorResponse);
};

const downloadSpocsFile = (filename = 'spocs.xlsx') => (
  downloadAdminFile('/admin/spocs/download', filename)
);

const getSpocsFileInfo = () => superFetch('/admin/spocs/file-info', { method: 'GET' })
  .then(response => response.json())
  .catch(parseAdminErrorResponse);

// Lease Validation Rules Management
const uploadLeaseValidationRulesFile = (file) => {
  return uploadAdminFile('/admin/lease-validation-rules/upload', file);
};

const bulkUpdateLeaseValidationRules = (updates, file = null) => {
  return bulkUpdateAdmin('/admin/lease-validation-rules/bulk-update', updates, file);
};

const fetchLeaseValidationRules = (page = 1, pageSize = 25, search = '') => {
  const params = new URLSearchParams({
    page: page.toString(),
    page_size: pageSize.toString(),
  });

  if (search && search.trim()) {
    params.append('search', search.trim());
  }

  const url = `/admin/lease-validation-rules?${params.toString()}`;
  const options = { method: 'GET' };
  return superFetch(url, options)
    .then(response => response.json());
};

const downloadLeaseValidationRulesFile = (filename = 'lease_validation_rules.xlsx') => {
  return downloadAdminFile('/admin/lease-validation-rules/download', filename);
};

const getLeaseValidationRulesFileInfo = () => {
  const url = '/admin/lease-validation-rules/file-info';
  const options = { method: 'GET' };
  return superFetch(url, options)
    .then(response => response.json());
};

const updateLeaseValidationRule = ({ attribute_key: attributeKey }, fields) => {
  const url = `/admin/lease-validation-rules/${encodeURIComponent(attributeKey)}`;
  const options = {
    method: 'PATCH',
    headers: { Authorization: `JWT ${authService.getToken()}`, 'Content-Type': 'application/json' },
  };
  return superFetch(url, options, JSON.stringify(fields))
    .then(response => response.json());
};

const fetchLeaseValidationRuleHistory = ({ attribute_key: attributeKey }, page = 1, pageSize = 10) => {
  const params = new URLSearchParams({
    page: page.toString(),
    page_size: pageSize.toString(),
  });
  const url = `/admin/lease-validation-rules/${encodeURIComponent(attributeKey)}/audit-history?${params.toString()}`;
  const options = { method: 'GET' };
  return superFetch(url, options)
    .then(response => response.json());
};

// Base Rent Validation Rules Management
const uploadBaseRentValidationRulesFile = (file) => {
  return uploadAdminFile('/admin/base-rent-validation-rules/upload', file);
};

const bulkUpdateBaseRentValidationRules = (updates, file = null) => {
  return bulkUpdateAdmin('/admin/base-rent-validation-rules/bulk-update', updates, file);
};

const fetchBaseRentValidationRules = (page = 1, pageSize = 25, search = '') => {
  const params = new URLSearchParams({
    page: page.toString(),
    page_size: pageSize.toString(),
  });

  if (search && search.trim()) {
    params.append('search', search.trim());
  }

  const url = `/admin/base-rent-validation-rules?${params.toString()}`;
  const options = { method: 'GET' };
  return superFetch(url, options)
    .then(response => response.json());
};

const downloadBaseRentValidationRulesFile = (filename = 'base_rent_validation_rules.xlsx') => {
  return downloadAdminFile('/admin/base-rent-validation-rules/download', filename);
};

const getBaseRentValidationRulesFileInfo = () => {
  const url = '/admin/base-rent-validation-rules/file-info';
  const options = { method: 'GET' };
  return superFetch(url, options)
    .then(response => response.json());
};

const updateBaseRentValidationRule = ({ market, property_type: propertyType }, fields) => {
  const url = '/admin/base-rent-validation-rules/update';
  const options = {
    method: 'PATCH',
    headers: { Authorization: `JWT ${authService.getToken()}`, 'Content-Type': 'application/json' },
  };
  return superFetch(url, options, JSON.stringify({ market, property_type: propertyType, ...fields }))
    .then(response => response.json());
};

const fetchBaseRentValidationRuleHistory = ({ market, property_type: propertyType }, page = 1, pageSize = 10) => {
  const params = new URLSearchParams({
    market,
    property_type: propertyType,
    page: page.toString(),
    page_size: pageSize.toString(),
  });
  const url = `/admin/base-rent-validation-rules/audit-history?${params.toString()}`;
  const options = { method: 'GET' };
  return superFetch(url, options)
    .then(response => response.json());
};

export {
  fetchTeamOptionsForAdmin,
  fetchTeamsForAdmin,
  addTeamForAdmin,
  updateTeamForAdmin,
  addTeamMemberForAdmin,
  removeTeamMemberForAdmin,
  fetchDealsAndTransactionsESForAdmin,
  linkDealsAndTransactionsForAdmin,
  unLinkDealsAndTransactionsForAdmin,
  fetchDealForAdmin,
  fetchGroups,
  fetchFlags,
  addGroup,
  fetchGroup,
  addUserToGroup,
  removeUserFromGroup,
  fetchUsers,
  fetchGroupUsers,
  addFlagToGroup,
  removeFlagFromGroup,
  turnOnFlagForAllUsers,
  turnOffFlagForAllUsers,
  exportBadTransactions,
  searchDealsForManagement,
  searchDealsRestoreManagement,
  getDealDetails,
  refreshUserDealData,
  fetchUserDealRefreshHistory,
  fetchUserDealRestrictions,
  fetchUserDealRestrictionsByUserIds,
  restoreDeletedDeal,
  fetchDealAudit,
  uploadPoolAccountsFile,
  bulkUpdatePoolAccounts,
  fetchPoolAccounts,
  downloadPoolAccountsFile,
  getPoolAccountsFileInfo,
  uploadFumosFile,
  bulkUpdateFumos,
  fetchFumos,
	downloadFumosFile,
	getFumosFileInfo,
  uploadSpocsFile,
  bulkUpdateSpocs,
  fetchSpocs,
  downloadSpocsFile,
  getSpocsFileInfo,
  uploadLeaseValidationRulesFile,
  bulkUpdateLeaseValidationRules,
  fetchLeaseValidationRules,
  downloadLeaseValidationRulesFile,
  getLeaseValidationRulesFileInfo,
  updateLeaseValidationRule,
  fetchLeaseValidationRuleHistory,
  uploadBaseRentValidationRulesFile,
  bulkUpdateBaseRentValidationRules,
  fetchBaseRentValidationRules,
  downloadBaseRentValidationRulesFile,
  getBaseRentValidationRulesFileInfo,
  updateBaseRentValidationRule,
  fetchBaseRentValidationRuleHistory,
  fetchPagedUserDealRestrictions,
  fetchCProUserAudit,
  updateUserDealRestrictions,
  searchAdminProxyUser,
  grantAdminProxyAccess,
  bulkValidateAdminProxyFile,
  bulkGrantAdminProxyAccess,
  revokeAdminProxyAccess,
  bulkRevokeAdminProxyAccess,
  fetchAdminProxyAccessList,
};
